import { render } from "./Employee_Profile.vue?vue&type=template&id=734616f2&scoped=true"
import script from "./Employee_Profile.vue?vue&type=script&lang=js"
export * from "./Employee_Profile.vue?vue&type=script&lang=js"

import "./Employee_Profile.vue?vue&type=style&index=0&id=734616f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734616f2"]])

export default __exports__